import { lazy } from "react";
import { ProtectedRoute } from "../components/ProtectedRoute.jsx";
import PasswordContextProvider from "../contexts/PasswordContext";

const chequeRouteConfig = [
  {
    parent: {
      exact: true,
      path: "/cheque/chequing",
      element: ProtectedRoute,
      permission_id: 7,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/chequing/DocumentChequing")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/cancelled",
      element: ProtectedRoute,
      permission_id: 40,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/chequing/DocumentChequingCancelled.jsx")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/debiting",
      element: ProtectedRoute,
      permission_id: 9,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/debiting/DocumentDebiting")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/transmitting",
      element: ProtectedRoute,
      permission_id: 23,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/signing/DocumentSigning")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/issuing",
      element: ProtectedRoute,
      permission_id: 24,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/issuing/DocumentIssuing")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/cheque-date-adjustment",
      element: ProtectedRoute,
      permission_id: 38,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() =>
        import("../routes/issuing/cheque-date-adjustment/DocumentChequingDateAdjustment.jsx")
      ),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/clearing",
      element: ProtectedRoute,
      permission_id: 8,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/clearing/DocumentClearing")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/releasing",
      element: ProtectedRoute,
      permission_id: 6,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/releasing/DocumentReleasing")),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: "/cheque/returned-cheques",
      element: ProtectedRoute,
      permission_id: 7,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import("../routes/chequing/returned/ReturnedDocument")),
      wrapper: PasswordContextProvider,
    },
  },
  //   {
  //     parent: {
  //       exact: true,
  //       path: "/cheque/returned-issues",
  //       element: ProtectedRoute,
  //       permission_id: 24,
  //     },
  //     child: {
  //       index: true,
  //       exact: true,
  //       strict: true,
  //       component: lazy(() => import("../routes/issuing/returned/ReturnedDocument")),
  //       wrapper: PasswordContextProvider,
  //     },
  //   },

  //   {
  //     parent: {
  //       exact: true,
  //       path: "/counter-receipt/creating",
  //       element: ProtectedRoute,
  //       permission_id: 6,
  //     },
  //     child: {
  //       index: true,
  //       exact: true,
  //       strict: true,
  //       component: lazy(() => import("../routes/countering/DocumentCounterReceiptCreating")),
  //       wrapper: PasswordContextProvider,
  //     },
  //   },
  //   {
  //     parent: {
  //       exact: true,
  //       path: "/counter-receipt/new-counter-receipt",
  //       element: ProtectedRoute,
  //       permission_id: 6,
  //     },
  //     child: {
  //       index: true,
  //       exact: true,
  //       strict: true,
  //       component: lazy(() => import("../routes/countering/NewCounterReceipt")),
  //       wrapper: PasswordContextProvider,
  //     },
  //   },
  //   {
  //     parent: {
  //       exact: true,
  //       path: "/counter-receipt/update-counter-receipt/:id",
  //       element: ProtectedRoute,
  //       permission_id: 6,
  //     },
  //     child: {
  //       index: true,
  //       exact: true,
  //       strict: true,
  //       component: lazy(() => import("../routes/countering/UpdateCounterReceipt")),
  //       wrapper: PasswordContextProvider,
  //     },
  //   },
  //   {
  //     parent: {
  //       exact: true,
  //       path: "/counter-receipt/monitoring",
  //       element: ProtectedRoute,
  //       permission_id: 6,
  //     },
  //     child: {
  //       index: true,
  //       exact: true,
  //       strict: true,
  //       component: lazy(() => import("../routes/countering/DocumentCounterReceiptMonitoring")),
  //       wrapper: PasswordContextProvider,
  //     },
  //   },
];

export default chequeRouteConfig;
